import { Modal } from "bootstrap";
import { User } from "../Models/User";
import { baseUrl } from "./commonUtils";

export async function getAuthenticatedUser() {
    const user = await $.getJSON(`${baseUrl}users/me.json`);
    return user as User;
}
/**
 * Déclaré dans le layout/default.php
 */
// declare const csrfToken: string;

export function getCsrfToken() {
    return window["csrfToken" as keyof Window];
}

export async function userIsAllowedTo(codeAction: string, module: string): Promise<boolean> {
    const res = await $.getJSON(`${baseUrl}users/isAllowed/${module}/${codeAction}.json`);
    return Boolean(res);
}

export async function checkUserSession() {
    const isConnected = await $.getJSON(`${baseUrl}users/isConnected.json`).catch(() => false);
    if (!isConnected) {
        $("#SessionEndModal .btn-login").attr(
            "href",
            `${baseUrl}users/login?redirect=${encodeURI(document.location.pathname)}`,
        );

        const sessionEndModal = Modal.getOrCreateInstance("#SessionEndModal", {
            backdrop: "static",
            keyboard: false,
        });
        sessionEndModal.show();
    }

    return isConnected;
}

export const genericNotAllowedMessage = "Vous n'êtes pas autorisé à effectuer cette action";
